import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import BusinessTypeSelector from './components/BusinessTypeSelector'
import SelectionTransition from './components/SelectionTransition'
import LandingPage from './pages/LandingPage'
import type { BusinessType } from './components/BusinessTypeSelector'

const STORAGE_KEY = 'varkwave_business_type'

function App() {
  const [businessType, setBusinessType] = React.useState<BusinessType>(null)
  const [showTransition, setShowTransition] = React.useState(false)
  const [transitionType, setTransitionType] = React.useState<BusinessType>(null)

  // Hydrate from sessionStorage on mount
  React.useEffect(() => {
    const stored = sessionStorage.getItem(STORAGE_KEY) as BusinessType | null
    if (stored && ['sales', 'school', 'transport'].includes(stored)) {
      setBusinessType(stored)
    }
  }, [])

  const handleSelect = (type: BusinessType) => {
    if (!type) return
    setTransitionType(type)
    setShowTransition(true)
  }

  const handleTransitionComplete = () => {
    if (transitionType) {
      sessionStorage.setItem(STORAGE_KEY, transitionType)
      setBusinessType(transitionType)
    }
    setShowTransition(false)
    setTransitionType(null)
  }

  const handleChangeBusinessType = () => {
    sessionStorage.removeItem(STORAGE_KEY)
    setBusinessType(null)
    setTransitionType(null)
    setShowTransition(false)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen"
    >
      <AnimatePresence mode="wait">
        {showTransition && transitionType && (
          <SelectionTransition
            key="transition"
            selectedType={transitionType}
            onComplete={handleTransitionComplete}
          />
        )}

        {!businessType && !showTransition && (
          <motion.div
            key="selector"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <BusinessTypeSelector onSelect={handleSelect} />
          </motion.div>
        )}

        {businessType && !showTransition && (
          <motion.div
            key="landing"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.4 }}
          >
            <LandingPage
              businessType={businessType}
              onChangeBusinessType={handleChangeBusinessType}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  )
}

export default App
